import { render, staticRenderFns } from "./Reqinspec.vue?vue&type=template&id=400dc0c6"
import script from "./Reqinspec.vue?vue&type=script&lang=js"
export * from "./Reqinspec.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports